import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "", ...rest }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

export const Overline = ({ children, className = "", dark = false }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <span className="h-px w-8 bg-gold" />
    <span className={`text-xs font-bold uppercase tracking-[0.25em] ${dark ? "text-gold-light" : "text-emerald-base"}`}>
      {children}
    </span>
  </div>
);
